import RSSScreen from './RSSScreen'

export default RSSScreen
